module.exports = __webpack_public_path__ + "blzee.acd6e5d1430d50e429c7.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/blzee/blzee.eot
// module id = ../../../../../src/assets/fonts/blzee/blzee.eot
// module chunks = styles